export var toError = Promise.reject.bind(Promise);